export default function clearImagePath(src, IMGIX_BASE = '') {
	if (src) {
		let imgPath = src.replace(/^(https?:|)\/\//, '') // Will remove the (http/https://) from the source and assign that to new variable imgPath = d3lf10b5gahyby.cloudfront.net/cityImages/75/singapore-1.jpg

		let origin = imgPath.split('/')[0] // this will split at [/] and return the first portion of the URL @origin name
		// Compare the origin to identify the respective imgIX url for the particular bucket.
		// IMGIX_BASE is '' setup against //s3.ap-south-1.amazonaws.com/oceanjar-new
		switch (origin) {
			case 'pyt-images.imgix.net': // is a cloudfront URL for the //s3.ap-south-1.amazonaws.com/oceanjar-new/images this bucket. So we have to add /images to imgIX URL to point to the proper bucket
				imgPath = imgPath.replace(`${origin}`, IMGIX_BASE)
				break
			case 'd3lf10b5gahyby.cloudfront.net': // is a cloudfront URL for the //s3.ap-south-1.amazonaws.com/oceanjar-new/images this bucket. So we have to add /images to imgIX URL to point to the proper bucket
				imgPath = imgPath.replace(origin, IMGIX_BASE)
				break
			case 's3.ap-south-1.amazonaws.com': // is the basic bucket URL
				imgPath = imgPath.replace(origin, IMGIX_BASE)
				if (imgPath?.includes('/oceanjar-new/images')) {
					// to check if the imgPath has /oceanjar-new text. return {true} if it has otherwise {false}
					imgPath = imgPath.replace('/oceanjar-new/images', '') // if we are replacing this to imgIX we have to make sure we have removed the /oceanjan-new bucket name from the URL.
				}
				break
			case 'oceanjar-new.s3.ap-south-1.amazonaws.com': // is the basic bucket URL
				imgPath = imgPath.replace(origin, IMGIX_BASE)
				if (imgPath?.includes('/oceanjar-new/images')) {
					// to check if the imgPath has /oceanjar-new text. return {true} if it has otherwise {false}
					imgPath = imgPath.replace('/oceanjar-new/images', '') // if we are replacing this to imgIX we have to make sure we have removed the /oceanjan-new bucket name from the URL.
				}
				break
			default:
				imgPath = src // if nothing matches re-assign src to imgPath
		}

		return imgPath
	}

	return src
}
